import React, { useEffect, useState } from 'react';
import inspectionStorage from '../services/inspectionStorage';

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #fef3c7, #fde68a)',
    paddingBottom: '100px'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 20px',
    background: 'linear-gradient(135deg, #f59e0b, #d97706)',
    color: 'white',
    position: 'sticky',
    top: 0,
    zIndex: 100
  },
  headerTitle: {
    fontSize: '18px',
    fontWeight: '700',
    margin: 0
  },
  backBtn: {
    background: 'rgba(255,255,255,0.2)',
    border: 'none',
    color: 'white',
    padding: '8px 16px',
    borderRadius: '8px',
    fontWeight: '600',
    cursor: 'pointer'
  },
  content: {
    padding: '16px'
  },
  card: {
    background: 'white',
    borderRadius: '12px',
    padding: '16px',
    marginBottom: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
  },
  cardTitle: {
    fontSize: '14px',
    fontWeight: '700',
    color: '#92400e',
    marginBottom: '8px'
  },
  groupHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '8px'
  },
  badge: {
    display: 'inline-block',
    padding: '4px 8px',
    borderRadius: '8px',
    background: '#fef3c7',
    color: '#92400e',
    fontSize: '11px',
    fontWeight: '700'
  },
  button: {
    padding: '8px 12px',
    background: '#f59e0b',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: '700'
  },
  buttonOutline: {
    padding: '8px 12px',
    background: 'white',
    color: '#92400e',
    border: '2px solid #f59e0b',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: '700'
  },
  item: {
    padding: '10px',
    borderRadius: '10px',
    border: '1px solid #e5e7eb',
    marginTop: '8px'
  },
  itemTitle: {
    fontSize: '13px',
    fontWeight: '700',
    color: '#1f2937'
  },
  itemMeta: {
    fontSize: '12px',
    color: '#6b7280'
  },
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.6)',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    zIndex: 3000
  },
  modal: {
    background: 'white',
    borderRadius: '20px 20px 0 0',
    width: '100%',
    maxHeight: '90vh',
    display: 'flex',
    flexDirection: 'column'
  },
  modalHeader: {
    padding: '16px',
    borderBottom: '1px solid #f3f4f6',
    fontWeight: '700',
    color: '#92400e',
    background: 'linear-gradient(135deg, #fffbeb, #fef3c7)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  modalTitle: {
    fontSize: '15px',
    fontWeight: '700',
    margin: 0
  },
  modalSubtitle: {
    fontSize: '12px',
    color: '#92400e',
    marginTop: '4px'
  },
  modalClose: {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    border: 'none',
    background: 'white',
    fontSize: '18px',
    cursor: 'pointer',
    boxShadow: '0 2px 6px rgba(0,0,0,0.08)'
  },
  modalBody: {
    padding: '16px',
    overflow: 'auto'
  },
  modalFooter: {
    padding: '16px',
    borderTop: '1px solid #f3f4f6',
    display: 'flex',
    gap: '10px'
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    fontSize: '14px',
    border: '2px solid #e5e7eb',
    borderRadius: '10px',
    background: '#f9fafb',
    color: '#111827',
    boxSizing: 'border-box',
    marginBottom: '10px'
  },
  formLabel: {
    display: 'block',
    fontSize: '12px',
    fontWeight: '600',
    color: '#374151',
    marginBottom: '6px'
  },
  checkboxRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '10px'
  },
  checkboxInput: {
    width: '16px',
    height: '16px'
  },
  textarea: {
    width: '100%',
    padding: '10px 12px',
    fontSize: '14px',
    border: '2px solid #e5e7eb',
    borderRadius: '10px',
    background: '#f9fafb',
    color: '#111827',
    boxSizing: 'border-box',
    minHeight: '70px',
    resize: 'vertical',
    marginBottom: '10px'
  },
  select: {
    width: '100%',
    padding: '10px 12px',
    fontSize: '14px',
    border: '2px solid #e5e7eb',
    borderRadius: '10px',
    background: '#f9fafb',
    color: '#111827',
    boxSizing: 'border-box',
    marginBottom: '10px'
  },
  saveSection: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    padding: '16px 20px',
    background: 'white',
    boxShadow: '0 -4px 16px rgba(0,0,0,0.1)'
  },
  saveButton: {
    width: '100%',
    padding: '16px',
    background: 'linear-gradient(135deg, #16a34a, #15803d)',
    border: 'none',
    borderRadius: '12px',
    color: 'white',
    fontSize: '16px',
    fontWeight: '700',
    cursor: 'pointer'
  }
};

export default function Etape2TableauEquipementsThermographieMobile({ mission, onBack, onSave }) {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [q19, setQ19] = useState({});
  const [equipements, setEquipements] = useState([]);

  const [showGroupModal, setShowGroupModal] = useState(false);
  const [showCategorieModal, setShowCategorieModal] = useState(false);
  const [showEquipementModal, setShowEquipementModal] = useState(false);

  const [newGroupe, setNewGroupe] = useState('');
  const [newCategorie, setNewCategorie] = useState('');
  const [currentGroupeIndex, setCurrentGroupeIndex] = useState(null);
  const [currentCategorieIndex, setCurrentCategorieIndex] = useState(null);
  const [editingEquipementIndex, setEditingEquipementIndex] = useState(null);

  const [currentEquipement, setCurrentEquipement] = useState({
    nature_designation: '',
    conditions_utilisation: 'Charge usuelle',
    defaut_fiche: '',
    sans_anomalie: false,
    examen_impossible: false,
    examen_impossible_raison: '',
    priorite: null,
    date_examen: new Date().toISOString().split('T')[0],
    thermogrammes: []
  });

  useEffect(() => {
    loadData();
  }, [mission.id]);

  const loadData = async () => {
    setLoading(true);
    try {
      const stored = await inspectionStorage.getStep(mission.id, 'rapport_q19_data');
      const base = stored || {};
      setQ19(base);
      setEquipements(base.equipements_controles || []);
    } catch (error) {
      console.error('❌ Erreur chargement équipements:', error);
    } finally {
      setLoading(false);
    }
  };

  const saveQ19 = async (updatedEquipements) => {
    const stored = await inspectionStorage.getStep(mission.id, 'rapport_q19_data');
    const nextQ19 = {
      ...(stored || {}),
      ...q19,
      equipements_controles: updatedEquipements
    };
    setQ19(nextQ19);
    setEquipements(updatedEquipements);
    await inspectionStorage.saveStep(mission.id, 'rapport_q19_data', nextQ19);
  };

  const handleAddGroupe = async () => {
    if (!newGroupe.trim()) return;
    const updated = [...equipements, { groupe_localisation: newGroupe.trim(), sous_categories: [] }];
    await saveQ19(updated);
    setNewGroupe('');
    setShowGroupModal(false);
  };

  const handleDeleteGroupe = async (groupeIndex) => {
    const updated = equipements.filter((_, i) => i !== groupeIndex);
    await saveQ19(updated);
  };

  const handleAddCategorie = async () => {
    if (!newCategorie.trim() || currentGroupeIndex === null) return;
    const updated = [...equipements];
    updated[currentGroupeIndex].sous_categories.push({
      nom: newCategorie.trim(),
      equipements: []
    });
    await saveQ19(updated);
    setNewCategorie('');
    setShowCategorieModal(false);
    setCurrentGroupeIndex(null);
  };

  const handleDeleteCategorie = async (groupeIndex, categorieIndex) => {
    const updated = [...equipements];
    updated[groupeIndex].sous_categories = updated[groupeIndex].sous_categories.filter((_, i) => i !== categorieIndex);
    await saveQ19(updated);
  };

  const openEquipementModal = (groupeIndex, categorieIndex, equipement = null, equipementIndex = null) => {
    setCurrentGroupeIndex(groupeIndex);
    setCurrentCategorieIndex(categorieIndex);
    setEditingEquipementIndex(equipementIndex);
    if (equipement) {
      setCurrentEquipement({ ...equipement });
    } else {
      setCurrentEquipement({
        nature_designation: '',
      conditions_utilisation: 'Charge usuelle',
        defaut_fiche: '',
        sans_anomalie: false,
        examen_impossible: false,
        examen_impossible_raison: '',
        priorite: null,
        date_examen: new Date().toISOString().split('T')[0],
        thermogrammes: []
      });
    }
    setShowEquipementModal(true);
  };

  const handleSaveEquipement = async () => {
    if (!currentEquipement.nature_designation.trim()) return;
    const normalized = {
      ...currentEquipement,
      defaut_fiche: (currentEquipement.sans_anomalie || currentEquipement.examen_impossible) ? '' : (currentEquipement.defaut_fiche || ''),
      priorite: (currentEquipement.sans_anomalie || currentEquipement.examen_impossible) ? null : currentEquipement.priorite
    };
    const updated = [...equipements];
    const list = updated[currentGroupeIndex].sous_categories[currentCategorieIndex].equipements;
    if (editingEquipementIndex !== null) {
      list[editingEquipementIndex] = { ...normalized };
    } else {
      list.push({ ...normalized });
    }
    await saveQ19(updated);
    setShowEquipementModal(false);
    setCurrentGroupeIndex(null);
    setCurrentCategorieIndex(null);
    setEditingEquipementIndex(null);
  };

  const handleDeleteEquipement = async (groupeIndex, categorieIndex, equipementIndex) => {
    const updated = [...equipements];
    updated[groupeIndex].sous_categories[categorieIndex].equipements =
      updated[groupeIndex].sous_categories[categorieIndex].equipements.filter((_, i) => i !== equipementIndex);
    await saveQ19(updated);
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const stored = await inspectionStorage.getStep(mission.id, 'rapport_q19_data');
      await inspectionStorage.saveStep(mission.id, 'rapport_q19_data', {
        ...(stored || {}),
        ...q19,
        equipements_controles: equipements
      });
      if (onSave) onSave({ equipements_controles: equipements });
      onBack();
    } catch (error) {
      console.error('❌ Erreur sauvegarde:', error);
      alert('Erreur lors de la sauvegarde');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#fef3c7' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ width: '40px', height: '40px', border: '4px solid #e5e7eb', borderTopColor: '#f59e0b', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto' }}></div>
          <p style={{ marginTop: '16px', color: '#92400e', fontWeight: '500' }}>Chargement...</p>
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={onBack}>← Retour</button>
        <h1 style={styles.headerTitle}>Équipements</h1>
        <button style={styles.backBtn} onClick={handleSave} disabled={saving}>
          {saving ? '⏳' : '💾'}
        </button>
      </div>

      <div style={styles.content}>
        <div style={styles.card}>
          <div style={styles.groupHeader}>
            <div style={styles.cardTitle}>📍 Groupes de localisation</div>
            <button style={styles.button} onClick={() => setShowGroupModal(true)}>+ Groupe</button>
          </div>
          {equipements.length === 0 && (
            <div style={styles.itemMeta}>Aucun groupe ajouté.</div>
          )}
        </div>

        {equipements.map((groupe, gIdx) => (
          <div key={gIdx} style={styles.card}>
            <div style={styles.groupHeader}>
              <div>
                <div style={styles.cardTitle}>{groupe.groupe_localisation}</div>
                <span style={styles.badge}>{groupe.sous_categories?.length || 0} catégorie(s)</span>
              </div>
              <div style={{ display: 'flex', gap: '8px' }}>
                <button style={styles.buttonOutline} onClick={() => { setCurrentGroupeIndex(gIdx); setShowCategorieModal(true); }}>+ Catégorie</button>
                <button style={{ ...styles.buttonOutline, borderColor: '#ef4444', color: '#b91c1c' }} onClick={() => handleDeleteGroupe(gIdx)}>Supprimer</button>
              </div>
            </div>

            {(groupe.sous_categories || []).map((cat, cIdx) => (
              <div key={`${gIdx}-${cIdx}`} style={styles.item}>
                <div style={styles.groupHeader}>
                  <div style={styles.itemTitle}>{cat.nom}</div>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <button style={styles.buttonOutline} onClick={() => openEquipementModal(gIdx, cIdx)}>+ Équipement</button>
                    <button style={{ ...styles.buttonOutline, borderColor: '#ef4444', color: '#b91c1c' }} onClick={() => handleDeleteCategorie(gIdx, cIdx)}>Supprimer</button>
                  </div>
                </div>

                {(cat.equipements || []).map((eq, eIdx) => (
                  <div key={`${gIdx}-${cIdx}-${eIdx}`} style={styles.item}>
                    <div style={styles.itemTitle}>{eq.nature_designation}</div>
                    <div style={styles.itemMeta}>
                      {(eq.conditions_utilisation === '' ? 'Vide' : (eq.conditions_utilisation || 'Charge usuelle'))} · {eq.date_examen || 'Date ?'} {eq.priorite ? `· P${eq.priorite}` : ''}
                      {eq.sans_anomalie ? ' · ✓ Sans anomalie' : ''}
                      {eq.examen_impossible ? ' · ⚠️ Examen impossible' : ''}
                    </div>
                    <div style={{ marginTop: '8px', display: 'flex', gap: '8px' }}>
                      <button style={styles.buttonOutline} onClick={() => openEquipementModal(gIdx, cIdx, eq, eIdx)}>Modifier</button>
                      <button style={{ ...styles.buttonOutline, borderColor: '#ef4444', color: '#b91c1c' }} onClick={() => handleDeleteEquipement(gIdx, cIdx, eIdx)}>Supprimer</button>
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        ))}
      </div>

      <div style={styles.saveSection}>
        <button style={{ ...styles.saveButton, ...(saving ? { opacity: 0.6, cursor: 'not-allowed' } : {}) }} onClick={handleSave} disabled={saving}>
          {saving ? '⏳ Sauvegarde...' : '💾 Sauvegarder'}
        </button>
      </div>

      {showGroupModal && (
        <div style={styles.overlay} onClick={() => setShowGroupModal(false)}>
          <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalHeader}>
              <div>
                <div style={styles.modalTitle}>Ajouter un groupe</div>
                <div style={styles.modalSubtitle}>Localisation principale</div>
              </div>
              <button style={styles.modalClose} onClick={() => setShowGroupModal(false)}>✕</button>
            </div>
            <div style={styles.modalBody}>
              <label style={styles.formLabel}>Nom du groupe</label>
              <input style={styles.input} placeholder="Ex: Atelier principal" value={newGroupe} onChange={(e) => setNewGroupe(e.target.value)} />
            </div>
            <div style={styles.modalFooter}>
              <button style={styles.buttonOutline} onClick={() => setShowGroupModal(false)}>Annuler</button>
              <button style={styles.button} onClick={handleAddGroupe}>Ajouter</button>
            </div>
          </div>
        </div>
      )}

      {showCategorieModal && (
        <div style={styles.overlay} onClick={() => setShowCategorieModal(false)}>
          <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalHeader}>
              <div>
                <div style={styles.modalTitle}>Ajouter une catégorie</div>
                <div style={styles.modalSubtitle}>Sous-zone ou bâtiment</div>
              </div>
              <button style={styles.modalClose} onClick={() => setShowCategorieModal(false)}>✕</button>
            </div>
            <div style={styles.modalBody}>
              <label style={styles.formLabel}>Nom de la catégorie</label>
              <input style={styles.input} placeholder="Ex: TGBT / Armoire 1" value={newCategorie} onChange={(e) => setNewCategorie(e.target.value)} />
            </div>
            <div style={styles.modalFooter}>
              <button style={styles.buttonOutline} onClick={() => setShowCategorieModal(false)}>Annuler</button>
              <button style={styles.button} onClick={handleAddCategorie}>Ajouter</button>
            </div>
          </div>
        </div>
      )}

      {showEquipementModal && (
        <div style={styles.overlay} onClick={() => setShowEquipementModal(false)}>
          <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalHeader}>
              <div>
                <div style={styles.modalTitle}>Équipement contrôlé</div>
                <div style={styles.modalSubtitle}>Détails de l’équipement</div>
              </div>
              <button style={styles.modalClose} onClick={() => setShowEquipementModal(false)}>✕</button>
            </div>
            <div style={styles.modalBody}>
              <label style={styles.formLabel}>Nature / Désignation</label>
              <input style={styles.input} placeholder="Ex: TGBT - départ armoire" value={currentEquipement.nature_designation} onChange={(e) => setCurrentEquipement(prev => ({ ...prev, nature_designation: e.target.value }))} />
              <label style={styles.formLabel}>Conditions d'utilisation</label>
              <select
                style={styles.select}
                value={currentEquipement.conditions_utilisation ?? ''}
                onChange={(e) => setCurrentEquipement(prev => ({ ...prev, conditions_utilisation: e.target.value }))}
              >
                <option value="Charge usuelle">Charge usuelle</option>
                <option value="FAIBLE">FAIBLE</option>
                <option value="Hors service">Hors service</option>
                <option value="">Vide</option>
              </select>
              <label style={styles.formLabel}>Date d'examen</label>
              <input type="date" style={styles.input} value={currentEquipement.date_examen} onChange={(e) => setCurrentEquipement(prev => ({ ...prev, date_examen: e.target.value }))} />
              <div style={styles.checkboxRow}>
                <input
                  style={styles.checkboxInput}
                  type="checkbox"
                  checked={!!currentEquipement.sans_anomalie}
                  onChange={(e) => setCurrentEquipement(prev => ({
                    ...prev,
                    sans_anomalie: e.target.checked,
                    examen_impossible: e.target.checked ? false : prev.examen_impossible,
                    priorite: e.target.checked ? null : prev.priorite,
                    defaut_fiche: e.target.checked ? '' : prev.defaut_fiche
                  }))}
                />
                <span>Sans anomalie</span>
              </div>
              <div style={styles.checkboxRow}>
                <input
                  style={styles.checkboxInput}
                  type="checkbox"
                  checked={!!currentEquipement.examen_impossible}
                  onChange={(e) => setCurrentEquipement(prev => ({
                    ...prev,
                    examen_impossible: e.target.checked,
                    sans_anomalie: e.target.checked ? false : prev.sans_anomalie,
                    priorite: e.target.checked ? null : prev.priorite,
                    defaut_fiche: e.target.checked ? '' : prev.defaut_fiche
                  }))}
                />
                <span>Examen impossible</span>
              </div>
              {!currentEquipement.sans_anomalie && !currentEquipement.examen_impossible && (
                <>
                  <label style={styles.formLabel}>N° fiche défaut</label>
                  <input
                    style={{ ...styles.input, background: '#f3f4f6', color: '#6b7280' }}
                    value={currentEquipement.defaut_fiche || ''}
                    disabled
                    placeholder="Automatique (étape 3)"
                  />
                  <label style={styles.formLabel}>Degré de priorité</label>
                  <select style={styles.select} value={currentEquipement.priorite || ''} onChange={(e) => setCurrentEquipement(prev => ({ ...prev, priorite: e.target.value ? Number(e.target.value) : null }))}>
                    <option value="">Sélectionner</option>
                    <option value="1">Priorité 1</option>
                    <option value="2">Priorité 2</option>
                    <option value="3">Priorité 3</option>
                  </select>
                </>
              )}
              {currentEquipement.examen_impossible && (
                <>
                  <label style={styles.formLabel}>Raison examen impossible</label>
                  <textarea style={styles.textarea} placeholder="Expliquez la raison..." value={currentEquipement.examen_impossible_raison || ''} onChange={(e) => setCurrentEquipement(prev => ({ ...prev, examen_impossible_raison: e.target.value }))} />
                </>
              )}
            </div>
            <div style={styles.modalFooter}>
              <button style={styles.buttonOutline} onClick={() => setShowEquipementModal(false)}>Annuler</button>
              <button style={styles.button} onClick={handleSaveEquipement}>Enregistrer</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
